import { render, staticRenderFns } from "./FilterSpeakers.vue?vue&type=template&id=01bfc820&"
import script from "./FilterSpeakers.vue?vue&type=script&lang=ts&"
export * from "./FilterSpeakers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports